define('views/modules/calendar/nutrition/entry/food-receptor-interface',['src/interface'], function(Interface) {

    var FoodReceptorInterface = {
        addEntry: Interface.NotImplemented,
        toggleChosen: Interface.NotImplemented,
    };

    return FoodReceptorInterface;

});

